import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Syllabus", href: "#syllabus" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "Readiness", href: "#readiness" },
  { label: "Your Host", href: "#host" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = ({ onRegister }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-[60] transition-all duration-500 ${
        scrolled
          ? "bg-ink/85 backdrop-blur-md border-b border-cream/10"
          : "bg-transparent"
      }`}
    >
      <nav className="container-tasha flex h-20 items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-logo"
          className="flex items-baseline gap-1 text-cream"
        >
          <span className="font-serif text-2xl font-semibold tracking-tight">#Ask</span>
          <span className="font-script text-3xl leading-none text-gold">Tasha</span>
        </button>

        <div className="hidden items-center gap-9 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="group relative font-sans text-sm uppercase tracking-[0.2em] text-cream/70 transition-colors hover:text-cream"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={onRegister}
            data-testid="nav-register-btn"
            className="hidden md:inline-flex btn-gold !px-6 !py-3 !text-xs"
          >
            Save Your Seat
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-menu-toggle"
            className="lg:hidden text-cream"
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="overflow-hidden border-t border-cream/10 bg-ink/95 backdrop-blur-md lg:hidden"
          >
            <div className="container-tasha flex flex-col gap-1 py-6">
              {LINKS.map((l) => (
                <button
                  key={l.href}
                  onClick={() => go(l.href)}
                  className="py-3 text-left font-serif text-2xl text-cream/80"
                >
                  {l.label}
                </button>
              ))}
              <button onClick={onRegister} className="btn-gold mt-4 w-full">
                Save Your Seat
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
